import css from 'styled-jsx/css'

import {  sizes } from '../../theme'


export default css`
  max-width: ${sizes.body.tablet.maxWidth};
  padding: 0;
  margin: 18rem auto;

  @media screen and (max-width: ${sizes.body.tablet.maxWidth}) {
    padding: 0 3rem;
  }

  @media screen and (max-width: ${sizes.media.smallTablet.maxWidth}) {
    margin: 12rem auto;
    padding: 0 2rem;
  }

  @media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
    margin: 7rem auto;
    margin-top: 30px;
  }
`
